module.exports = __webpack_public_path__ + "img/sld_mfm_ic_2_t1_b1_dark.a9d13aed.svg";